/**
 * [ui1006, paczka PROC, projekt 4.4] GRUPY CZĘŚCI KARTY PROCEDURY — 18 części w 5 grupach po ≤ 4 (etapy 1–4 i „Dane i historia”).
 * Osobny plik (bez importów), bo czyta go rejestr obszarów (`procedury.js`) i karta procedury (`KartaProceduryObiekt.js`).
 * Adres: `?doc=ID&etap=1..4|dane&czesc=<kod>`.
 */
export const GRUPY_CZESCI_PROCEDURY = Object.freeze([
    Object.freeze({ id: "1", etykieta: "Przygotowanie", czesci: Object.freeze(["tresc", "pliki", "wersje", "wyslij"]) }),
    Object.freeze({ id: "2", etykieta: "Zatwierdzenie", czesci: Object.freeze(["recenzja", "glosowanie", "papier"]) }),
    Object.freeze({ id: "3", etykieta: "Publikacja", czesci: Object.freeze(["publikacja", "czytelnicy", "adresaci", "potwierdzenia"]) }),
    Object.freeze({ id: "4", etykieta: "Pilnowanie", czesci: Object.freeze(["przeglady", "kontrole", "wycofanie"]) }),
    Object.freeze({ id: "dane", etykieta: "Dane i historia", czesci: Object.freeze(["opis", "wyjatki", "historia", "audytor"]) }),
]);

export default GRUPY_CZESCI_PROCEDURY;
